import React, { PropsWithChildren } from 'react'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { hideModal } from '../../../../app/store/reducers/AppSlice'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { useTranslation } from 'react-i18next'

interface ConfirmModalProps extends PropsWithChildren {
  title: string
  onConfirm?: () => void
  onDelete?: () => void
  onCancel?: () => void
}

export const ConfirmModal = ({
  title,
  onConfirm,
  onDelete,
  onCancel,
  children,
}: ConfirmModalProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <div className={'py-[40px] px-[16px] text-focus-500'}>
      <p className={'text-center text-[24px] font-medium'}>{title}</p>
      <p className={'pb-[32px] pt-[8px] text-center text-[15px]'}>{children}</p>
      <div className={'flex justify-center gap-[12px]'}>
        {onConfirm && (
          <BpButton
            className={'uppercase'}
            onClick={() => {
              dispatch(hideModal())
              onConfirm()
            }}
          >
            {t('buttons.confirm')}
          </BpButton>
        )}
        {onDelete && (
          <BpButton
            className={'uppercase'}
            theme={'danger'}
            onClick={() => {
              dispatch(hideModal())
              onDelete()
            }}
          >
            {t('buttons.delete')}
          </BpButton>
        )}
        <BpButton
          className={'uppercase'}
          theme={'outline'}
          onClick={() => {
            dispatch(hideModal())
            onCancel && onCancel()
          }}
        >
          {t('buttons.cancel')}
        </BpButton>
      </div>
    </div>
  )
}
